import React, { useEffect, useState } from 'react';
import { Typography, Stack, Box, Button } from '@mui/material';
import DataGridTable from '../../../Components/DataGrid';
import AutoCompleteComponent from '../../../Components/AutoCompleteComponenet';
import { getEmailConfigColumns, useEmailConfig, FolderSelectDropdown } from '../../../Components/EmailConfig';
import { handleValidateCodevalue } from '../../../Utility/constant';
import { useSelector, useDispatch } from 'react-redux';
import { requestShowLoader, requestHideLoader } from '../../../Store/Global/action';
import { useSnackbar } from 'notistack';
import BiztantuLoader from '../../../Components/Loader';
import { StyledConfigurationContainer, StyledLeadContainer, StyledSubHeader } from '../../../Components/Styled';
import '../../Template/template.css';

const EmailToTaskDialog = ({}) => {
    const ownerList = useSelector(state => state?.owner?.ownerlist);
    const myTeam = useSelector(state => state?.owner?.Team);
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();

    const [selectedAssignee, setSelectedAssignee] = useState(null);
    const [requiredAssignee, setRequiredAssignee] = useState(false);


    const handleSetRequired = () => {
        setRequiredAssignee(true);
    };

    const {
        fromDataGridData,
        fromRowModesModel,
        handleFromEditClick,
        handleFromSaveClick,
        handleFromCancelClick,
        processIMapRowUpdate,
        selectedFolders,
        availableFolders,
        foldersLoading,
        handleFolderChange,
        saveImapConfig,
    } = useEmailConfig({
        selectedUser : currentUser,
        getUrl: 'api/client/email-config',
        saveUrl: 'api/client/email-config',
        fromType: "EMAIL_TO_TASK",
        handleSetRequired: handleSetRequired,
        defaultAssignee: selectedAssignee
    });
    useEffect(() => {
  
  if (!fromDataGridData?.length) return;

  if (ownerList?.length > 0 && fromDataGridData?.[0]?.defaultAssignee) {
    const foundAssignee = ownerList.find(
      item => item.id === fromDataGridData?.[0]?.defaultAssignee
    );
    setSelectedAssignee(
      foundAssignee || {
        firstName: currentUser.firstname,
        lastName: currentUser.lastname,
        id: currentUser.userId,
      }
    );
  } else {
    setSelectedAssignee({
      firstName: currentUser.firstname,
      lastName: currentUser.lastname,
      id: currentUser.userId,
    });

  }
}, [currentUser, ownerList,fromDataGridData]);

    const fromColumns = getEmailConfigColumns({
        rowModesModel: fromRowModesModel,
        handleEditClick: handleFromEditClick,
        handleSaveClick: handleFromSaveClick,
        handleCancelClick: handleFromCancelClick,
        internationalise,
        isIMap: true,
        canEdit: (specificRolePermission?.isNotificationManage &&  (specificRolePermission?.isTaskTeamManage || specificRolePermission?.isAllTaskManage)),
    });

    const handleSelectAssignee = (event, Assignee) => {
        setSelectedAssignee(Assignee);
        if (Assignee) {
            setRequiredAssignee(false);
        }
    };
    
    const handleSaveConfig = async () => {
        if (!selectedAssignee) {
            setRequiredAssignee(true);
            return;
        }
        dispatch(requestShowLoader());
        const success = await saveImapConfig(selectedAssignee?.id);
        dispatch(requestHideLoader());
        if (success) {
        }
    };

    return (
            <BiztantuLoader isChildren={true} open={foldersLoading}>
            <StyledLeadContainer>
                <StyledConfigurationContainer className="email-to-task-header-container">
                <Typography variant='h6'>
                    {handleValidateCodevalue(internationalise, 'EMAIL_TO_TASK_TITLE')}
                </Typography>
            </StyledConfigurationContainer>
            </StyledLeadContainer>
            <Box className="email-to-task-content-box">
            <StyledSubHeader className="email-to-task-subheader">
                {handleValidateCodevalue(internationalise, "TASKS_EMAIL_TO_TASK_DETAILS")}
            </StyledSubHeader>
            <DataGridTable
                height='125px'
                rowModesModel={fromRowModesModel}
                columns={fromColumns}
                isRequiredToolBar={false}
                isCheckboxReq={false}
                dataGridData={fromDataGridData}
                handleProcessRowUpdate={(newRow, oldRow) => processIMapRowUpdate(newRow, oldRow)}
                hideFooter={true}
            />
            <Stack className="email-to-task-row-pl">
            <FolderSelectDropdown
                selectedFolders={selectedFolders}
                availableFolders={availableFolders}
                foldersLoading={foldersLoading}
                onFolderChange={(newValue) => handleFolderChange(null, newValue)}
                disabled={!fromDataGridData?.[0]?.imapHost || !(specificRolePermission?.isTaskTeamManage || specificRolePermission?.isAllTaskManage)}
                internationalise={internationalise}
                className="email-to-task-dropdown"
            />
            </Stack>
            <StyledSubHeader className='mt-20'>
                {handleValidateCodevalue(internationalise, "TASKS_ASSIGN_TO")}
            </StyledSubHeader>
            <Stack className="email-to-task-row">
            <AutoCompleteComponent
                className="email-to-task-autocomplete"
                isOwner={true}
                optionSet={(specificRolePermission?.isAllTaskManage ? ownerList
                    : specificRolePermission?.isTaskTeamManage ? myTeam
                        : [{
                            firstName: `${currentUser?.firstname}`,
                            lastName: `${currentUser?.lastname}`,
                            id: currentUser?.userId,
                        }]) || []}
                value={selectedAssignee}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                disabled={!(specificRolePermission?.isAllTaskManage || specificRolePermission?.isTaskTeamManage)}
                name="ownerId"
                placeholder={handleValidateCodevalue(internationalise, 'TASK_SEARCH_OWNER')}
                error={!selectedAssignee && requiredAssignee}
                required={true}
                label={handleValidateCodevalue(internationalise, 'TASK_SEARCH_OWNER')}
                onChange={handleSelectAssignee}
            />
            </Stack>

            <Stack className="email-to-task-btn-row">
            {specificRolePermission?.isNotificationManage &&
            <Button
                className='biztantu-sec-btn'
                variant="contained"
                size="small"
                onClick={handleSaveConfig}
            >
                {handleValidateCodevalue(internationalise, 'COMMON_SAVE')}
            </Button>
            }
            </Stack>
            </Box>
            </BiztantuLoader>
    );
};

export default EmailToTaskDialog;
